export default __webpack_public_path__ + "static/media/gunshot - 808 - L_1.c05d3f7b.wav";